import { ROUTES } from "./routes"
import { faUser, faUserPlus, faBuildings, faBullhorn } from "@fortawesome/pro-light-svg-icons"
import { traderTierHandler } from "./tiers/trader"

export const ORG_TYPES = {
  TIERED_SELF_SERVE: "tiered_self_self",
  SALES_PROSPECTING: "sales_prospecting",
  FREE_TRIAL: "free_trial",
}

export const PRODUCT_TIERS = {
  MAX: "max",
  PRO: "pro",
  ENTERPRISE: "enterprise",
  TRADER: "trader",
}

export const ADVERTISE_TIER_CONTENT = {
  disabled: true,
  icon: faUser,
  tierName: "Max",
  description: "Lorem ipsum dolor sit amet consectetur. Ullamcorper in a ac tellus imperdiet integer quam egestas et.",
  includedFeatures: ["Lorem ipsum dolor sit amet consectetur.", "Lorem ipsum dolor sit amet consectetur."],
  missingFeatures: ["Lorem ipsum dolor sit amet consectetur."],
  clickHandler: () => window.location.assign(`${ROUTES.SELFSERVE_SIGNUP}?tier=advertise_free`),
  buttonText: "Sign Up"
}

export const ADVERTISE_PRO_TIER_CONTENT = {
  disabled: true,
  icon: faUserPlus,
  tierName: "Pro",
  description: "Lorem ipsum dolor sit amet consectetur. Ullamcorper in a ac tellus imperdiet integer quam egestas et.",
  includedFeatures: ["Lorem ipsum dolor sit amet consectetur.", "Lorem ipsum dolor sit amet consectetur."],
  missingFeatures: ["Lorem ipsum dolor sit amet consectetur."],
  clickHandler: () => {},
  buttonText: "Sign Up"
}

export const ENTERPRISE_TIER_CONTENT = {
  disabled: true,
  icon: faBuildings,
  tierName: "Enterprise",
  description: "Lorem ipsum dolor sit amet consectetur. Ullamcorper in a ac tellus imperdiet integer quam egestas et.",
  includedFeatures: ["Lorem ipsum dolor sit amet consectetur.", "Lorem ipsum dolor sit amet consectetur."],
  missingFeatures: ["Lorem ipsum dolor sit amet consectetur."],
  clickHandler: () => {},
  buttonText: "Contact Us"
}


export const TRADER_TIER_CONTENT = {
  disabled: false,
  icon: faBullhorn,
  tierName: "Trader",
  description: "Are you a trader at a large agency or agency holding company? We’re ready to tailor terms to your bespoke needs.",
  includedFeatures: ["Full custom products and services", "Pick and choose what works for your business", "Custom business terms"],
  missingFeatures: [],
  clickHandler: traderTierHandler,
  buttonText: "Contact Us"
}